import type { FaireProductEntity } from "../../entity_types/product";

export const p_5sv4tyep7g: FaireProductEntity = {
  token: "p_5sv4tyep7g",
  type: "product",
  name: "CK NECK OVERSIZED POPCORN KNIT SWEATER TUNIC",
  brandToken: "b_2a388unpqo",
  brandName: "Bluivy",
  imageUrl: "https://cdn.faire.com/fastly/f4892a1e04ba5256b3c1b35486d90f7d327e87c8bfb0a9fdabe2bdc6e9bae356.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/3256ea1d6696b0aa51ea123b6247f5bf4833fd09b8172b475f7b8b5f8b3881fa.jpeg",
    "https://cdn.faire.com/fastly/c5360e94c1072214a2649377bf32f8aba1fd726aa184afd98936649313585514.jpeg",
    "https://cdn.faire.com/fastly/7a62568c4c46920d21e6c6fdae2a2a691623115eb1b93fabea239fafbda8cd70.jpeg",
    "https://cdn.faire.com/fastly/7e3e09cf3c3a0a8515cca48b4c14830ec494b11d0b8b54cb227e95b81b251141.jpeg",
    "https://cdn.faire.com/fastly/246f45c96aa032138007b099b65fb01264603306d280aa60f708a2b9ec57ce01.jpeg",
    "https://cdn.faire.com/fastly/b5b22e359a61a08f01ab9da3206cf5256862cacd4bad5e270990560585859721.jpeg",
    "https://cdn.faire.com/fastly/4c7fe5a28b5a030ac5da9f317393fe8d462e03b8da3ebf7d4bc8d642434097f4.jpeg",
    "https://cdn.faire.com/fastly/38e7b3d09b05658e06307b241a2352e478013474320d5a57a5daddc44796de9e.jpeg",
    "https://cdn.faire.com/fastly/132dc0c1b18fd368a10c888610e63241e20d0f7d1b6c4d38f0203def3ca5684e.jpeg",
    "https://cdn.faire.com/fastly/0f911eea736866122bbcd52d8e604d9a6a9927234f94e3b507f6c02577591fd4.jpeg",
    "https://cdn.faire.com/fastly/2f44e45c318e35294fc1919a9454100d294f5db5fe3da0f72d03d2395ad52957.jpeg",
    "https://cdn.faire.com/fastly/7cf937960e82c4db34fa1408fe7832ea72cc36aa866ed594c3730a94bd4674e9.jpeg",
    "https://cdn.faire.com/fastly/bb828fbabacf4ade0d63974577359ded4ee28fd79573861c1438f94c7d46a274.jpeg",
    "https://cdn.faire.com/fastly/80679ce47220e16c3abc040c89fb39ff8c73701ee11e86cb1d0199d20135f022.jpeg",
    "https://cdn.faire.com/fastly/1e8d4d94c05a6acdebd12b42ec4f2cc2c29fa0d86bcbbcc3a7e752c6a809b479.jpeg",
    "https://cdn.faire.com/fastly/f7c77c6895243a89c858943b9fe9cc41c5b17b6a546f0c64cfd332903204b965.jpeg",
    "https://cdn.faire.com/fastly/81829badc944163d58e7a97d37ba36d8327bb98065b91e59869532e5eb814d5c.jpeg",
    "https://cdn.faire.com/fastly/b89bd2923d8f7c0d31e8bcfaa86fb44c7d8492341bedb2993e8b87c458ed0070.jpeg",
    "https://cdn.faire.com/fastly/5506bfb46000f7b6a31e3c130623f5270c7ed76f1cffdda228a0767a9574930b.jpeg",
    "https://cdn.faire.com/fastly/51a9133d81bc35c7a385734e7965c4c9be7e47fd5378d5fd5ba264112007b89e.jpeg",
    "https://cdn.faire.com/fastly/c4c8561498db6b6e3104cad90ad2315f8066a7e9c27c2b047992f3d07ffa1894.jpeg",
    "https://cdn.faire.com/fastly/7772794d483471fbaec8cb742816aefe25a05a0893ef1508cb0c78a74a7c5d0d.jpeg"
  ],
  priceDollars: 154.8,
  description: "Elevate your cozy-weather wardrobe with this beautifully textured pullover. This heavy-gauge sweater is defined by its intricate \"popcorn\" style knit, offering an artisanal, hand-crafted look and feel. The rich rust-brown hue adds seasonal warmth to any ensemble, while the relaxed mock neck features a subtle rolled edge for a modern touch. Designed with dropped shoulders and an effortless longline fit, this plush sweater provides maximum comfort without sacrificing style.\n\n-Fabric: Extra-chunky, high-texture popcorn knit yarn.\n-Neckline: High mock neck with a relaxed rolled finish.\n-Fit: Oversized, longline silhouette with dropped shoulder seams.\n-Sleeves: Full-length sleeves with a consistent textured pattern.\n-Size: Model is 5'9\" and wearing a S/M.",
  tags: [],
  msrpDollars: 309.6,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-28T21:03:42.560Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
